if ($('body.page-template-page-projects').length > 0) {
  filterHandler.onItemAdded = function($item, $displayDiv) {
    console.log("masuk");
    var $projectCarousel = $item.find('.project-images-carousel');
    if ($projectCarousel.length > 0 && $projectCarousel.is(':visible')) {
      $projectCarousel.flickity({
        cellAlign: 'center',
        draggable: false,
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: false,
        fullscreen: false,
        prevNextButtons: false,
        autoPlay: 2000, 
        pauseAutoPlayOnHover: false,
      });
      $projectCarousel.flickity('pausePlayer');
      $projectCarousel.parents('a')
        .on('mouseenter', function() {
          $projectCarousel.flickity('select', 1, true, false);
          $projectCarousel.flickity('playPlayer');
        })
        .on('mouseleave', function() {
          $projectCarousel.flickity('stopPlayer');
          $projectCarousel.flickity('select', 0, true, true);
        });
    }
  };
}

$(document).ready(function($) {
})
